"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var isFunction_1 = tslib_1.__importDefault(require("lodash/isFunction"));
var _modal_1 = tslib_1.__importDefault(require("../_components/_modal"));
var PromptCheckCircleFill_1 = require("../Icons/PromptCheckCircleFill");
var DelayModal = (0, react_1.forwardRef)(function (_a, ref) {
    var _b = _a.width, width = _b === void 0 ? 400 : _b, title = _a.title, renderContent = _a.renderContent, callBack = _a.callBack, propsDelay = _a.delay;
    var _c = tslib_1.__read((0, react_1.useState)(propsDelay), 2), delay = _c[0], setDelay = _c[1];
    var _d = tslib_1.__read((0, react_1.useState)(false), 2), visible = _d[0], setVisible = _d[1];
    (0, react_1.useImperativeHandle)(ref, function () { return ({
        open: function () {
            setVisible(true);
        },
        close: function () {
            setVisible(false);
        },
    }); }, []);
    (0, react_1.useEffect)(function () {
        var timer;
        var handler = function () {
            setDelay(function (val) {
                if (val === 1) {
                    callBack && callBack();
                }
                else {
                    timer = setTimeout(handler, 1000);
                }
                return Math.max(0, val - 1);
            });
        };
        if (visible) {
            setDelay(propsDelay);
            timer = setTimeout(handler, 1000);
        }
        return function () {
            clearTimeout(timer);
        };
    }, [visible, propsDelay, callBack]);
    return (react_1.default.createElement(_modal_1.default, { width: width, visible: visible, footer: null, closable: false, className: "delayModal", centered: true },
        react_1.default.createElement("div", { className: "icon" },
            react_1.default.createElement(PromptCheckCircleFill_1.PromptCheckCircleFill, null)),
        react_1.default.createElement("div", { className: "title" }, (0, isFunction_1.default)(title) ? title(delay) : title),
        renderContent ? react_1.default.createElement("div", { className: "content" }, renderContent(delay)) : null));
});
exports.default = DelayModal;
//# sourceMappingURL=anqDelayModal.js.map